window.refreshable = function() {
  $.each($('.refreshable'), function( index, elem ) {
    $(elem).on('change', function() {
      $(this).closest('form').find('input.refresh').val('1')
      $(this).closest('form').find("input[name='commit']").trigger('click')
    })
  })
}